/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Select_Caption_TrackInputs */

const en_embed_captions_select_caption_track = /** @type {(inputs: Embed_Captions_Select_Caption_TrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select a caption track`)
};

const fr_embed_captions_select_caption_track = /** @type {(inputs: Embed_Captions_Select_Caption_TrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez selectionner une piste de sous-titres`)
};

const de_embed_captions_select_caption_track = /** @type {(inputs: Embed_Captions_Select_Caption_TrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte wählen Sie eine Untertitelspur aus.`)
};

const it_embed_captions_select_caption_track = /** @type {(inputs: Embed_Captions_Select_Caption_TrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona una traccia di sottotitoli`)
};

const ru_embed_captions_select_caption_track = /** @type {(inputs: Embed_Captions_Select_Caption_TrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, выберите дорожку субтитров.`)
};

const es_embed_captions_select_caption_track = /** @type {(inputs: Embed_Captions_Select_Caption_TrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor seleccione una pista de subtítulos`)
};

const zh_cn2_embed_captions_select_caption_track = /** @type {(inputs: Embed_Captions_Select_Caption_TrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请选择字幕轨道`)
};

const ja_embed_captions_select_caption_track = /** @type {(inputs: Embed_Captions_Select_Caption_TrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャプショントラックを選択してください`)
};

const hi_embed_captions_select_caption_track = /** @type {(inputs: Embed_Captions_Select_Caption_TrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया कैप्शन ट्रैक चुनें`)
};

const pt_pt2_embed_captions_select_caption_track = /** @type {(inputs: Embed_Captions_Select_Caption_TrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, selecione uma faixa de legenda.`)
};

/**
* | output |
* | --- |
* | "Please select a caption track" |
*
* @param {Embed_Captions_Select_Caption_TrackInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_select_caption_track = /** @type {((inputs?: Embed_Captions_Select_Caption_TrackInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Select_Caption_TrackInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_select_caption_track(inputs)
	if (locale === "de") return de_embed_captions_select_caption_track(inputs)
	if (locale === "it") return it_embed_captions_select_caption_track(inputs)
	if (locale === "ru") return ru_embed_captions_select_caption_track(inputs)
	if (locale === "es") return es_embed_captions_select_caption_track(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_select_caption_track(inputs)
	if (locale === "ja") return ja_embed_captions_select_caption_track(inputs)
	if (locale === "hi") return hi_embed_captions_select_caption_track(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_select_caption_track(inputs)
	return en_embed_captions_select_caption_track(inputs)
});